import nvSdcModule from '../../../sdc/nv.sdcModule.module';

angular.module(nvSdcModule).component('toolbarFiltersWidget', {
  template: require('./toolbar-filters-widget.html'),
  bindings: {
    // note: checkboxes is a boolean. If set to true, a checkbox is displayed for each filter.
    checkboxes: '<',
    filteredStudentsCount: '=',
    totalStudentsCount: '<',
    parsedFilterParam: '<',
  },
  controller: 'ToolbarFiltersWidgetCtrl',
});
